import React, { useState, useRef } from 'react';
import { 
  FaShieldAlt, 
  FaMoneyBillWave, 
  FaClock, 
  FaHeadset 
} from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useEffect } from 'react';
// import CarIcon from "../Assests/Car14Red.svg"; // Import as URL, not component


const RunningCar = ({ src, alt, style }) => {
  const [position, setPosition] = useState(0);
  
  useEffect(() => {
    // Slower interval for the blur effect (was 50ms, now 100ms)
    const interval = setInterval(() => {
      setPosition(prev => (prev + 1) % 100);
    }, 100); // Increased from 50ms to 100ms
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ position: 'relative', marginBottom: '-40px', overflow: 'hidden', ...style }}>
      {/* Speed lines background - slower */}
      <div style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
        {[...Array(8)].map((_, i) => ( // Reduced number of speed lines from 10 to 8
          <motion.div
            key={i}
            style={{
              position: 'absolute',
              top: `${20 + i * 10}%`, // Increased spacing
              right: 0,
              width: `${40 + i * 8}px`, // Wider lines
              height: '3px', // Thicker lines
              background: `rgba(231, 18, 4, ${0.25 - i * 0.02})`, // Slightly more transparent
              borderRadius: '3px',
            }}
            animate={{
              x: [200, -250], // Longer travel distance
              opacity: [0, 0.6, 0], // Lower max opacity
            }}
            transition={{
              duration: 1.5, // Increased from 0.8 to 1.5 seconds
              repeat: Infinity,
              delay: i * 0.15, // Increased delay
              ease: "linear",
            }}
          />
        ))}
      </div>

      {/* Car with slower motion */}
      <motion.div
        animate={{
          x: [-3, 3, -2, 2, -1, 1, 0], // Smaller movement range
          y: [0, -0.5, 0.5, -0.3, 0.3, 0], // Subtler vertical movement
          scale: [1, 1.01, 0.99, 1.005, 1], // Smaller scale changes
        }}
        transition={{
          duration: 0.8, // Increased from 0.2 to 0.8 seconds
          repeat: Infinity,
          repeatType: "loop",
          ease: "easeInOut",
        }}
        style={{
          position: 'relative',
          zIndex: 2,
          filter: `blur(${Math.sin(position * 0.05) * 0.15}px)`, // Slower blur variation
        }}
      >
        <img src={src} alt={alt} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
      </motion.div>

      {/* Slower motion blur effect */}
      <motion.div
        style={{
          position: 'absolute',
          top: 0,
          right: -30,
          width: '60px', // Wider blur
          height: '100%',
          background: 'linear-gradient(90deg, transparent, rgba(231,18,4,0.15), transparent)',
          zIndex: 3,
        }}
        animate={{
          x: [-40, 50], // Longer travel distance
          opacity: [0, 0.3, 0], // Lower opacity
        }}
        transition={{
          duration: 1.2, // Increased from 0.6 to 1.2 seconds
          repeat: Infinity,
          ease: "linear",
        }}
      />

      {/* Add subtle shadow under car for realism */}
      <motion.div
        style={{
          position: 'absolute',
          bottom: '-5px',
          left: '15%',
          width: '70%',
          height: '10px',
          background: 'rgba(0,0,0,0.1)',
          borderRadius: '50%',
          filter: 'blur(3px)',
          zIndex: 1,
        }}
        animate={{
          scaleX: [1, 1.02, 0.98, 1],
          opacity: [0.3, 0.4, 0.3],
        }}
        transition={{
          duration: 1,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
    </div>
  );
};
const cards = [
  {
    img: 'https://news.northeastern.edu/wp-content/uploads/2015/10/102815_MM_uber_001-11.jpg',
    title: 'No surge pricing',
    desc: 'Confirmed price stays fixed. No surprises, ever.',
    tag: 'Best Price',
    stat: '40% cheaper',
    color: '#16a34a',
    bg: '#f0fdf4',
  },
  {
    img: 'https://taxitaxi.in/wp-content/uploads/2025/11/Generated-Image-November-12-2025-4_40PM.png',
    title: 'No hidden charges',
    desc: 'What you see is exactly what you pay.',
    tag: 'Transparent',
    stat: '100% safe',
    color: '#2563eb',
    bg: '#eff6ff',
  },
  {
    img: 'https://5.imimg.com/data5/SELLER/Default/2022/11/QN/OJ/UY/64310247/permanent-car-driver-service.jpg',
    title: 'Top-rated drivers',
    desc: 'Trained, verified, and loved by millions.',
    tag: 'Top Rated',
    stat: '4.9 ★',
    color: '#d97706',
    bg: '#fffbeb',
  },
];

const stats = [
  { value: '10k+', label: 'Riders' },
  { value: '500+', label: 'Cities' },
  { value: '4.9★', label: 'Rating' },
  { value: '24/7', label: 'Support' },
];

export default function WhyRide() {

  const CarIcon ='https://openclipart.org/download/285548/Car14Red.svg'
  const [active, setActive] = useState(0);
  const scrollRef = useRef(null);

  const goTo = (i) => {
    setActive(i);
    if (scrollRef.current) {
      const el = scrollRef.current.children[i];
      el?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
  };

  const handleScroll = () => {
    if (!scrollRef.current) return;
    const { scrollLeft, offsetWidth } = scrollRef.current;
    setActive(Math.round(scrollLeft / (offsetWidth * 0.8 + 12)));
  };

  return (
    <div style={{background:'#f8f8f8', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}>

      {/* ─── DESKTOP ─────────────────────────────────── */}
      <div className="d-desktop ">
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '64px 24px' }}>
          <h2 style={{ fontSize: 30, fontWeight: 800, color: '#111', margin: '0 0 6px' }}>Why Ride With Us</h2>
          <p style={{ fontSize: 15, color: '#888', margin: '0 0 40px' }}>The best way to travel to your destination</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 28 }}>
            {cards.map((c, i) => (
              <div key={i}>
                <div style={{ borderRadius: 18, overflow: 'hidden', height: 300, marginBottom: 20 }}>
                  <img src={c.img} alt={c.title}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }} />
                </div>
                <h3 style={{ fontSize: 18, fontWeight: 700, color: '#111', margin: '0 0 8px' }}>{c.title}</h3>
                <p style={{ fontSize: 14, color: '#777', margin: 0, lineHeight: 1.7 }}>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ─── MOBILE ──────────────────────────────────── */}
      <div className="d-mobile" style={{ background: '#f6f6f6', minHeight: '100vh' }}>

        {/* Status bar */}
     

        {/* Top white section */}
        <div style={{ background: '#fff', padding: '20px 20px 28px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <p style={{ fontSize: 12, fontWeight: 600, color: '#e71204', margin: '0 0 4px', letterSpacing: 0.5, textTransform: 'uppercase' }}>Why choose us</p>
              <h2 style={{ fontSize: 26, fontWeight: 900, color: '#111', margin: 0, lineHeight: 1.2, letterSpacing: -0.5 }}>
                Ride smarter,<br />ride safer.
              </h2>
            </div>
            <div>
 <RunningCar src={CarIcon} alt="KAYAK" style={{ width: 170, height: 120 }} />

  </div>
          </div>

          {/* Stat pills */}
          <div style={{ display: 'flex', gap: 8, marginTop: 20, flexWrap: 'wrap' }}>
            {stats.map((s, i) => (
              <div key={i} style={{
                background: i === 0 ? '#e71204' : '#f4f4f4',
                borderRadius: 30, padding: '7px 16px',
                display: 'flex', alignItems: 'center', gap: 5,
              }}>
                <span style={{ fontSize: 13, fontWeight: 800, color: i === 0 ? '#fff' : '#111' }}>{s.value}</span>
                <span style={{ fontSize: 11, color: i === 0 ? 'rgba(255,255,255,0.75)' : '#999', fontWeight: 500 }}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Cards label */}
        <div style={{ padding: '22px 20px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 16, fontWeight: 800, color: '#111' }}>Our features</span>
          <span style={{ fontSize: 12, color: '#aaa', fontWeight: 500 }}>{active + 1} / {cards.length}</span>
        </div>

        {/* Snap cards */}
        <div
          ref={scrollRef}
          onScroll={handleScroll}
          style={{
            display: 'flex', gap: 12, overflowX: 'auto',
            padding: '4px 20px 20px',
            scrollSnapType: 'x mandatory',
            scrollbarWidth: 'none',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          {cards.map((c, i) => (
            <div key={i} style={{
              flex: '0 0 80%', scrollSnapAlign: 'start',
              background: '#fff', borderRadius: 24,
              overflow: 'hidden',
              boxShadow: active === i ? '0 10px 36px rgba(0,0,0,0.12)' : '0 2px 12px rgba(0,0,0,0.06)',
              border: '1px solid #f0f0f0',
              transition: 'box-shadow 0.3s',
            }}>
              <div style={{ position: 'relative', height: 190 }}>
                <img src={c.img} alt={c.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }} />
                <div style={{
                  position: 'absolute', inset: 0,
                  background: 'linear-gradient(to bottom, transparent 50%, rgba(0,0,0,0.5) 100%)',
                }} />
                <div style={{
                  position: 'absolute', bottom: 14, left: 14, right: 14,
                  display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end',
                }}>
                  <span style={{
                    background: '#fff', color: '#111', fontSize: 11, fontWeight: 800,
                    padding: '4px 10px', borderRadius: 20,
                  }}>{c.tag}</span>
                  <span style={{
                    background: c.color, color: '#fff', fontSize: 11, fontWeight: 700,
                    padding: '4px 10px', borderRadius: 20,
                  }}>{c.stat}</span>
                </div>
              </div>
              <div style={{ padding: '16px 18px 20px' }}>
                <div style={{ fontSize: 15, fontWeight: 800, color: '#111', marginBottom: 6 }}>{c.title}</div>
                <div style={{ fontSize: 13, color: '#888', lineHeight: 1.6 }}>{c.desc}</div>
                <div style={{
                  marginTop: 14, display: 'inline-flex', alignItems: 'center', gap: 4,
                  color: c.color, fontSize: 13, fontWeight: 700,
                }}>
                  Learn more
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dot indicators */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: -8, marginBottom: 22 }}>
          {cards.map((_, i) => (
            <button key={i} onClick={() => goTo(i)} style={{
              width: active === i ? 22 : 7, height: 7, borderRadius: 4,
              background: active === i ? '#e71204' : '#ddd',
              border: 'none', cursor: 'pointer', padding: 0,
              transition: 'all 0.25s',
            }} />
          ))}
        </div>

        {/* Simple list rows */}
        <div style={{ margin: '0 16px 20px', background: '#fff', borderRadius: 22, overflow: 'hidden', border: '1px solid #f0f0f0' }}>
          {[
            { emoji: <FaShieldAlt/>, label: 'Verified drivers', sub: 'Background-checked & trained' },
            { emoji: <FaMoneyBillWave/>, label: 'Fixed pricing', sub: 'No surge, ever' },
            { emoji: <FaClock/>, label: '98% on time', sub: 'Punctuality guaranteed' },
            { emoji: <FaHeadset/>, label: '24/7 support', sub: 'We\'re always here' },
          ].map((row, i, arr) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', gap: 14,
              padding: '15px 18px',
              borderBottom: i < arr.length - 1 ? '1px solid #f5f5f5' : 'none',
            }}>
              <div style={{
                width: 42, height: 42, borderRadius: 13, background: '#f6f6f6',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 20, flexShrink: 0,
              }}>{row.emoji}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#111', marginBottom: 2 }}>{row.label}</div>
                <div style={{ fontSize: 12, color: '#aaa' }}>{row.sub}</div>
              </div>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6"/></svg>
            </div>
          ))}
        </div>

        {/* CTA */}
        {/* <div style={{ margin: '0 16px 36px' }}>
          <button style={{
            width: '100%', padding: '17px',
            background: '#e71204', border: 'none', borderRadius: 18,
            fontSize: 15, fontWeight: 800, color: '#fff',
            cursor: 'pointer', letterSpacing: 0.2,
            boxShadow: '0 8px 24px #e7120435',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          }}>
            Book your first ride
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </button>
        </div> */}

        {/* Home indicator */}
        {/* <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 16 }}>
          <div style={{ width: 110, height: 5, background: '#000', opacity: 0.12, borderRadius: 999 }} />
        </div> */}
      </div>

      <style>{`
        @media (min-width: 768px) { .d-desktop{display:block!important} .d-mobile{display:none!important} }
        @media (max-width: 767px) { .d-desktop{display:none!important} .d-mobile{display:block!important} }
        div::-webkit-scrollbar { display: none; }
      `}</style>
    </div>
  );
}